module.exports = __webpack_public_path__ + "img/hopital.8124cdd2.png";